import React, { FC } from 'react';

import cn from 'classnames';
import dayjs from 'dayjs';
import { inject, observer } from 'mobx-react';
import dynamic from 'next/dynamic';
import Image from 'next/legacy/image';

import { Button } from '@element/index';
import { helper, I18n } from '@utils/index';
import { airdropReceiveStatus, airdropStatus, defaultNickname } from '@widget/airdrop/constants';
import { CardDown } from '@widget/airdrop/countdown';
import { usePrecision } from '@widget/airdrop/hooks/usePrecision';
// import Link from 'next/link';
import { FollowBtn } from '@widget/community';

import { useUsdRate } from '../../hooks/useUsdRate';
import { AirdropSimpleType } from '../detail';

import styles from './index.module.less';
const AirdropUserinfo = dynamic(
  () => import('@components/UserInfo').then((module) => module.AirdropUserinfo),
  { ssr: false }
);
const defaultAvatar = require('@images/defaultAvatar.webp');
interface BtnProps {
  callback: () => void;
  btnText: string;
  className?: string;
  tip?: string,
  action?: string,
  loading?: boolean
};
const OpenBtn: FC<BtnProps> = (props) => {
  const { callback, btnText, tip, className, action, loading = false } = props;
  return <div className={styles.bottom}>
    <Button type='primary' loading={loading}
      className={cn(styles.openBtn, className, 'DINPro')}
      onClick={callback} data-buried={action}>{btnText}</Button>
    {tip && <p className={cn(styles.tip, 'DINPro')}>{tip}</p>}
  </div>
};
const mapContent = (status) => {
  switch (status) {
    case 1:
      return {
        btnText: I18n.t('hWGI8S6k'),
        action: 'share-airdrop',
        className: styles['share-airdrop-btn']
      };
    case 5:
      return {
        btnText: I18n.t('go_to_trade'),
        tip: I18n.t('5pAtx38n'),
        action: 'to-trade'
      };
    case 3:
    case 6:
    case 7:
    case 8:
    case 9:
      return {
        btnText: I18n.t('MgHqiFW2'),
        className: 'ghost',
        action: 'next-one'
      };
    default:
      return {
        btnText: ''
      }
  }
}
const T: FC<AirdropSimpleType> = (props) => {
  const {
    status, nickName, avatar, amount,
    currency, expiredTime, greeting, loading = false,
    onClickAirdrop, userInfo, userStore
  } = props;
  const { isFollower, customerId } = userInfo;
  const rate = useUsdRate({ coinCode: currency });
  const { usdRate } = currency === 'USDC' ? { usdRate: 1 } : rate;
  const onClick = () => {
    onClickAirdrop(props);
  }
  // 保留金额位数
  const getSlice = (str:string, num: number) => {
    // const limit = num < 15 ? num : 15
    const currency = helper.formatFixNumString(str, num);
    return currency;
  };
  const getUSD = () => {
    const currency = (Number(amount) * usdRate);
    return currency.toString().length > 15 ? currency.toString().slice(0, 15) : currency
  };
  return (
    <div className={styles.container}>
        <div className={styles.message}>
            <AirdropUserinfo
              // LinkTag={Link}
              // LinkTagProps= {getLinkHref}
              ImgTag={Image}
              imgTagProps={{ width: '44', height: '44', layout: 'fixed' }}
              src={avatar || defaultAvatar}
              desc={I18n.t('Q14l5ZA3')}
              nickname={nickName || defaultNickname.nickName}
              className={styles.userInfo}/>
            {(customerId && customerId !== userStore?.userInfo?.id) && <FollowBtn type="primary"
                size="md"
                isFollow={isFollower}
                toCustomerId={customerId}
                className={styles.followBtn}/>}
        </div>
        <div className={styles.base}>
            <div className={cn(styles.currency, {
              [styles.isActived]: status === airdropReceiveStatus.activeSuccess
            })}>
                <span className={cn(styles.title, 'DINPro')}>{I18n.t('LE73Mfxm')}</span>
                <div className={styles.allCount}>
                  <div className={styles.eth}>{getSlice(amount, usePrecision({ coinCode: currency }))} {currency}</div>
                  <div className={cn(styles.usd, 'DINPro')}>≈{getUSD()} USD</div>
                </div>
            </div>
            {!!(status !== airdropReceiveStatus.activeSuccess) && <div className={styles.time}>
              <CardDown
                endTime={status === airdropStatus.drew ? dayjs().unix() : Number(expiredTime) / 1000}
                id={'briefCuntDown'}/>
            </div>}
        </div>
        <p className={styles.greeting}>
            <span className='DINPro'>{I18n.t('SwdIsdEq')}</span>
            <span>{greeting}</span>
        </p>
        <OpenBtn {...mapContent(status)} callback={onClick} loading={loading}/>
    </div>
  );
};

export const BriefDetail = inject((rootStore: {
  store: {
    userStore: {
      userInfo: { id: string }
    }
  }
}) => {
  return {
    userStore: rootStore.store.userStore
  };
})(observer(T));
